/* esm.sh - applesauce-react@5.1.0/dist/providers/factory-provider */
export * from "/*applesauce-react@5.1.0/esnext/dist/providers/factory-provider.mjs";
